<template>
  <div id="forgotPasswordPage" class="container">
    <router-link :to="{ name: 'loginPage' }">
      <img
        class="logo"
        :src="`/images/logo-font-${isDark ? 'white' : 'black'}.svg`"
        alt="Logo yuzu"
      />
    </router-link>
    <h2 v-text="'Entrez votre nouveau mot de passe'" />
    <p>
      Choisissez un mot de passe différent de l’ancien et suffisamment complexe.
    </p>
    <VForm
      :button="{
        label: 'Réinitialiser votre mot de passe',
        class: 'primary full-size',
        hotDisabled: true,
      }"
      :callback="submit"
    >
      <template #form-body="{ errors }">
        <VField
          type="password"
          placeholder="••••••••••••"
          name="password"
          v-model="state.password"
          rules="required|password"
          label="Nouveau mot de passe"
          :helper="$t('form.register.must8char')"
          :class="{ invalid: Object.keys(errors)[0] === 'password' }"
        />
        <VField
          type="password"
          placeholder="••••••••••••"
          name="confirmPassword"
          v-model="state.confirmPassword"
          rules="required|match:@password"
          label="Confirmer le nouveau mot de passe"
          :class="{ invalid: Object.keys(errors)[0] === 'confirmPassword' }"
        />
      </template>
    </VForm>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive } from "vue";
import { useDark } from "@vueuse/core";
import { useUserStore } from "@/stores/user.js";
import { useCompanyStore } from "@/stores/company.js";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { setToken } from "@/composables/token.js";
import { getError } from "@/composables/error.js";

const isDark = useDark();

const toast = useToast();

const router = useRouter();

const route = useRoute();

const userStore = useUserStore();

const companyStore = useCompanyStore();

const { auth_token } = storeToRefs(userStore);

const state = reactive({
  password: "",
  confirmPassword: "",
});

if (!route.query.reset_id) {
  router.push({ name: "loginPage" });
}

async function submit() {
  const resp = await userStore.resetPassword(
    route.query.reset_id,
    state.password
  );

  if (resp.token) {
    setToken(resp.token, "auth_token", auth_token);
    userStore.setUser({
      ...resp.user,
    });

    companyStore.companies = resp.companies;

    await companyStore.getCompany(resp.companies[0].company_id);

    router.push({
      name: "home",
      params: { companyId: companyStore.companies[0].company_id },
    });

    toast.success("Votre mot de passe a bien été modifié.");
  } else {
    toast.error(getError(resp.key));
  }
}
</script>
